"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MAX_DEPTH = 50;
const findAttribute = (element, attribute) => {
    let currentElement = element;
    let currentDepth = 0;
    while (currentElement !== null && currentDepth < MAX_DEPTH) {
        if (currentElement.getAttribute(attribute) !== null &&
            currentElement.getAttribute(attribute) !== '') {
            return currentElement.getAttribute(attribute);
        }
        if (currentElement.parentElement !== null && currentElement.parentElement !== undefined) {
            currentElement = currentElement.parentElement;
            currentDepth++;
        }
        else {
            return null;
        }
    }
    return null;
};
exports.default = findAttribute;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmluZEF0dHJpYnV0ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy91dGlscy9keW5hbWljQ29udGV4dC9maW5kQXR0cmlidXRlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsTUFBTSxTQUFTLEdBQUcsRUFBRSxDQUFDO0FBRXJCLE1BQU0sYUFBYSxHQUFHLENBQUMsT0FBb0IsRUFBRSxTQUFpQixFQUFpQixFQUFFO0lBQzdFLElBQUksY0FBYyxHQUFHLE9BQU8sQ0FBQztJQUM3QixJQUFJLFlBQVksR0FBRyxDQUFDLENBQUM7SUFFckIsT0FBTyxjQUFjLEtBQUssSUFBSSxJQUFJLFlBQVksR0FBRyxTQUFTLEVBQUU7UUFDeEQsSUFDSSxjQUFjLENBQUMsWUFBWSxDQUFDLFNBQVMsQ0FBQyxLQUFLLElBQUk7WUFDL0MsY0FBYyxDQUFDLFlBQVksQ0FBQyxTQUFTLENBQUMsS0FBSyxFQUFFLEVBQy9DO1lBQ0UsT0FBTyxjQUFjLENBQUMsWUFBWSxDQUFDLFNBQVMsQ0FBQyxDQUFDO1NBQ2pEO1FBRUQsSUFBSSxjQUFjLENBQUMsYUFBYSxLQUFLLElBQUksSUFBSSxjQUFjLENBQUMsYUFBYSxLQUFLLFNBQVMsRUFBRTtZQUNyRixjQUFjLEdBQUcsY0FBYyxDQUFDLGFBQWEsQ0FBQztZQUM5QyxZQUFZLEVBQUUsQ0FBQztTQUNsQjthQUFNO1lBQ0gsT0FBTyxJQUFJLENBQUM7U0FDZjtLQUNKO0lBRUQsT0FBTyxJQUFJLENBQUM7QUFDaEIsQ0FBQyxDQUFDO0FBRUYsa0JBQWUsYUFBYSxDQUFDIn0=


// WEBPACK FOOTER //
// ../../../../src/utils/dynamicContext/findAttribute.ts